export const multiPreselectedFieldTheme = {
  bg: 'palette.surface.5',
  borderColor: 'palette.transparent',
  borderRadius: '12px',
  borderWidth: '0px',
  label: 'palette.tertiary.60',
};
